import { TimeZone } from '@treadinc/horizon-api-spec';

interface ResolveSiteTimeZoneParams {
  areHoursBeingSetOnZonelessSite: boolean;
  companyTimeZone: TimeZone | null;
  currentTimeZone: TimeZone | null;
  inferredTimeZone: TimeZone | null;
  isLocationNew: boolean;
}

/**
 * A new site or a moved pin takes the zone of its coordinates, so it never keeps the
 * previous location's zone. Otherwise the saved zone wins, so an engineer's console
 * override survives an unrelated edit. Blank hours mean open 24 hours and need no zone,
 * so a site saved without one only gets it once someone sets its hours. When the
 * coordinates give no zone (none entered, or open water), the company's zone is used.
 */
export function resolveSiteTimeZone({
  areHoursBeingSetOnZonelessSite,
  companyTimeZone,
  currentTimeZone,
  inferredTimeZone,
  isLocationNew,
}: ResolveSiteTimeZoneParams) {
  if (isLocationNew) {
    return inferredTimeZone ?? companyTimeZone;
  }

  if (areHoursBeingSetOnZonelessSite) {
    return inferredTimeZone ?? currentTimeZone ?? companyTimeZone;
  }

  return currentTimeZone;
}
